import React from "react";
import Layout from "../../components/layout/Layout/Layout";
import Header from "../../components/layout/Header/Header";
import PastEvents from "../../components/global/Event/collections/PastEvents";
import UpcomingEvents from "../../components/global/Event/collections/UpcomingEvents";
import { formatTitle } from "../../utils/helper";
import BaseWineSearchBar from "../../components/global/SearchBar/BaseWineSearchBar";
import Head from "next/head";
import { getEvents } from "../../lib/eventRequests";

export default function EventsPage({upcomingEvents, pastEvents}) {
  return (
    <Layout disableMeta={true}>
      <Head>
        <title>{formatTitle("Events")}</title>
        <meta name="description" content="Explore upcoming and past events on Vinous." />
        <meta name="keywords" content="events, wine events, Vinous events" />
        <link rel="canonical" href="https://vinous.com/events" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="google-translate-customization"
          content="bc9c404857e6094b-bd2091ef6a1aacc6-g5523c9461670c8e8-21"
        />
      </Head>
      <Header></Header>
      <BaseWineSearchBar className="pb-8" hideResults={true} />
      <UpcomingEvents upcoming_events={upcomingEvents}/>
      <PastEvents className="mt-8" past_events={pastEvents} />
    </Layout>
  );
}

export const getServerSideProps = async () => {
  const { data } = await getEvents();

  return {
    props: {
      upcomingEvents: data.upcoming || [],
      pastEvents: data.past || [],
    },
  };
};
